export function toDate(value) {
    return value instanceof Date ? new Date(value.getTime()) : new Date(value);
}

export function getTime(date) {
    return toDate(date).getTime();
}

export function startOfDay(date = new Date()) {
    const d = toDate(date);
    d.setHours(0, 0, 0, 0);
    return d;
}
